import { Injectable } from '@angular/core';

@Injectable()
export class HomeGuestUserService {
    guestSession = false;
}
